import { TuiSkeleton } from '@taiga-ui/kit';
import { TuiBlockStatus } from '@taiga-ui/layout';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { IsLoadingService } from '@core/services';
import { SvgIconComponent } from '@common/components/svg-icon/svg-icon.component';

@Component({
  selector: 'x-empty-block',
  imports: [TuiSkeleton, SvgIconComponent, CommonModule, TuiBlockStatus],
  templateUrl: './empty-block.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyBlockComponent {
  readonly isLoading$: BehaviorSubject<boolean> = inject(IsLoadingService);

  readonly $title = input<string>('', {
    alias: 'title',
  });
}
